// Unpublished Work © 2024 Deere & Company.

export const JDF_COUNTRIES_LIST = ['US', 'CA'];
